module.exports = __webpack_public_path__ + "static/media/technologies.82330880.jpg";